
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/well/ranking/[slug]/[year]/[id]",
      function () {
        return require("private-next-pages/well/ranking/[slug]/[year]/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/well/ranking/[slug]/[year]/[id]"])
      });
    }
  